import {
  words,
  marginOfSessionTime,
} from './globalState';
import {
  getValidKeyPairs,
  certificationWithKey,
  setSignatureByAddressMain,
  signWithKey,
  getAddressFromKey,
  checkIfAddressIsMatchedWithAnAddress,
} from './keysAndSigning';
import {
  setAddressesInCookie,
} from './monacottoMisc';
import {
  syncHttpRequest2,
  devLog,
} from './utils';

// 「履歴」ボタン押下 HANDLE CLICK GET EXHIBIT HISTORY
async function handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, pagingIndex, activeCertification, consistentRead, keyPairs) {
  // let addressActual;
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  devLog('activeCertification', JSON.stringify(activeCertification));

  if (activeCertification === undefined || activeCertification === null) {
    activeCertification = [];
    // activeCertification = {
    //   address: null,
    // };
  }

  if (consistentRead === undefined || consistentRead === null) {
    consistentRead = false;
  }

  // state固定
  const stateFixed = {
    addressMain: state.getHistory.addressMain,
    lastEvaluatedExhibitNo: pagingIndex >= 1 ? state.getHistory.lastEvaluatedKey.exhibit[pagingIndex - 1].exhibitNo : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getExhibitHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  devLog('session', JSON.stringify(state.session));
  for (const address of Object.keys(state.session)) {

    // activeCertificationの場合は別処理
    // if (address !== activeCertification.address) 
    if ( !activeCertification.map( certification => certification.address ).includes(address) ) {

      // -- state固定
      stateFixed[address] = {
        // addressCoinType: state.session[address].addressCoinType,
        sessionId: state.session[address].sessionId,
        expirationOfSession: state.session[address].expirationOfSession,
      };

      // -- 絞り込み
      devLog(stateFixed[address].expirationOfSession, now);
      if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
      devLog('push');
        certifications.push({
          // addressCoinType: stateFixed[address].addressCoinType,
          address: address,
          sessionId: stateFixed[address].sessionId,
          lastEvaluatedExhibitNo: address === stateFixed.addressMain ? stateFixed.lastEvaluatedExhibitNo : null,
          consistentRead: address === stateFixed.addressMain ? consistentRead : false,
        });
      }
    }
  }

  for (const certification of activeCertification) {
    // -- state固定
    stateFixed[certification.address] = {
      sessionId: certification.sessionId,
      expirationOfSession: certification.expirationOfSession,
    };

    // -- 有効だったら(まあほぼ有効なんだろうけど)プッシュ
    if (stateFixed[certification.address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        address: certification.address,
        sessionId: stateFixed[certification.address].sessionId,
        lastEvaluatedExhibitNo: null, // activeCertificationは常に先頭を検索する。
        consistentRead: true, // activeCertificationは常に強力な整合性のある読み込みをする。
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
    { key: 'consistentRead', value: consistentRead },
    { key: 'lastEvaluatedExhibitNo', value: stateFixed.lastEvaluatedExhibitNo },
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return;
  }

  request.body = JSON.stringify({
    "body": {
      "certifications": certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'exhibitHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'lastEvaluatedKey', 'exhibit', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'lastEvaluatedKey', 'exhibit', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'pagingIndex', 'exhibit'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getHistory.addressMain === undefined || state.getHistory.addressMain === null || state.getHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchExhibitHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return;
  }
}

// 「購入:検索」ボタン押下 HANDLE CLICK GET PURCHASE HISTORY
async function handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, pagingIndex, activeCertification, consistentRead, keyPairs) {
  // let addressActual;
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  if (activeCertification === undefined || activeCertification === null) {
    activeCertification = {
      address: null,
    };
  }

  if (consistentRead === undefined || consistentRead === null) {
    consistentRead = false;
  }

  // state固定
  const stateFixed = {
    addressMain: state.getHistory.addressMain,
    lastEvaluatedPurchaseNo: pagingIndex >= 1 ? state.getHistory.lastEvaluatedKey.purchase[pagingIndex - 1].purchaseNo : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getPurchaseHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {

    // activeCertificationの場合は別処理
    if (address !== activeCertification.address) {

      // state固定
      stateFixed[address] = {
        // addressCoinType: state.session[address].addressCoinType,
        sessionId: state.session[address].sessionId,
        expirationOfSession: state.session[address].expirationOfSession,
      };

      if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
        certifications.push({
          // addressCoinType: stateFixed[address].addressCoinType,
          address: address,
          sessionId: stateFixed[address].sessionId,
          lastEvaluatedPurchaseNo: address === stateFixed.addressMain ? stateFixed.lastEvaluatedPurchaseNo : null,
          consistentRead: address === stateFixed.addressMain ? consistentRead : false,
        });
      }
    }
  }

  // activeCertificationの処理

  if (activeCertification.address !== null) {
    // -- state固定
    stateFixed[activeCertification.address] = {
      sessionId: activeCertification.sessionId,
      expirationOfSession: activeCertification.expirationOfSession,
    };

    // -- 有効だったら(まあほぼ有効なんだろうけど)プッシュ
    if (stateFixed[activeCertification.address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        address: activeCertification.address,
        sessionId: stateFixed[activeCertification.address].sessionId,
        lastEvaluatedExhibitNo: null, // activeCertificationは常に先頭を検索する。
        consistentRead: true, // activeCertificationは常に強力な整合性のある読み込みをする。
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
    { key: 'consistentRead', value: consistentRead },
    { key: 'lastEvaluatedPurchaseNo', value: stateFixed.lastEvaluatedPurchaseNo },
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    "body": {
      "certifications": certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_purchase_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'purchaseHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'lastEvaluatedKey', 'purchase', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'lastEvaluatedKey', 'purchase', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'pagingIndex', 'purchase'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getHistory.addressMain === undefined || state.getHistory.addressMain === null || state.getHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchPurchaseHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「売上履歴」ボタン押下 HANDLE CLICK GET SALES HISTORY
async function handleClickGetSalesHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.getHistory.addressMain,
    lastEvaluatedSortKey: pagingIndex >= 1 ? state.getHistory.lastEvaluatedKey.sales[pagingIndex - 1].receiveMonaConfirmationTime : null,
    lastEvaluatedTablePartitionKey: pagingIndex >= 1 ? state.getHistory.lastEvaluatedKey.sales[pagingIndex - 1].addressMain : null,
    lastEvaluatedTableSortkey: pagingIndex >= 1 ? state.getHistory.lastEvaluatedKey.sales[pagingIndex - 1].purchaseNo : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getPurchaseHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {

      // state固定
      stateFixed[address] = {
        sessionId: state.session[address].sessionId,
        expirationOfSession: state.session[address].expirationOfSession,
      };

      if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
        certifications.push({
          address: address,
          sessionId: stateFixed[address].sessionId,
          lastEvaluatedSortKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedSortKey : null,
          lastEvaluatedTablePartitionKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedTablePartitionKey : null,
          lastEvaluatedTableSortkey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedTableSortkey : null,
        });
      }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
    { key: 'lastEvaluatedTablePartitionKey', value: stateFixed.lastEvaluatedTablePartitionKey },
    { key: 'lastEvaluatedTableSortkey', value: stateFixed.lastEvaluatedTableSortkey },
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    body: {
      action: 'sales',
      certifications: certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_some_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'salesHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'lastEvaluatedKey', 'sales', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'lastEvaluatedKey', 'sales', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'pagingIndex', 'sales'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getHistory.addressMain === undefined || state.getHistory.addressMain === null || state.getHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchSalesHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「ロイヤリティ履歴」ボタン押下 HANDLE CLICK GET ROYALTY HISTORY
async function handleClickGetRoyaltyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs) {
  let request = {};
  let messages = {};
  let certifications = [];
  let stateKey;
  let combinedAction;
  const now = Date.now();

  // addressType毎の設定
  if (state.getHistory.addressType === 'addressOwner') {
    stateKey = 'royaltyAddressOwnerHistory';
    combinedAction = 'royaltyAddressOwner';
  }
  else { // addressPayRoyaltyTo
    stateKey = 'royaltyAddressPayRoyaltyToHistory';
    combinedAction = 'royaltyAddressPayRoyaltyTo';
  }

  // state固定
  const stateFixed = {
    addressMain: state.getHistory.addressMain,
    addressType: state.getHistory.addressType,
    lastEvaluatedSortKey: pagingIndex >= 1 ? state.getHistory.lastEvaluatedKey[combinedAction][pagingIndex - 1].receiveMonaConfirmationTime : null,
    lastEvaluatedTablePartitionKey: pagingIndex >= 1 ? state.getHistory.lastEvaluatedKey[combinedAction][pagingIndex - 1].addressMain : null,
    lastEvaluatedTableSortkey: pagingIndex >= 1 ? state.getHistory.lastEvaluatedKey[combinedAction][pagingIndex - 1].purchaseNo : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getRoyaltyHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {

      // state固定
      stateFixed[address] = {
        sessionId: state.session[address].sessionId,
        expirationOfSession: state.session[address].expirationOfSession,
      };

      if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
        certifications.push({
          address: address,
          addressType: stateFixed.addressType,
          sessionId: stateFixed[address].sessionId,
          lastEvaluatedSortKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedSortKey : null,
          lastEvaluatedTablePartitionKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedTablePartitionKey : null,
          lastEvaluatedTableSortkey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedTableSortkey : null,
        });
      }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
    { key: 'addressType', value: stateFixed.addressType },
    { key: 'lastEvaluatedTablePartitionKey', value: stateFixed.lastEvaluatedTablePartitionKey },
    { key: 'lastEvaluatedTableSortkey', value: stateFixed.lastEvaluatedTableSortkey },
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    body: {
      action: 'royalty',
      certifications: certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_some_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, stateKey, undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'lastEvaluatedKey', combinedAction, pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'lastEvaluatedKey', combinedAction, pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'pagingIndex', combinedAction], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getHistory.addressMain === undefined || state.getHistory.addressMain === null || state.getHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchRoyaltyHistory',
              addressType: stateFixed.addressType,
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「出品キャンセル：署名」ボタン押下 -- HANDLE CLICK SIGN CANCEL EXHIBIT
async function handleClickSignCancelExhibit(state, dispatch, cookies, setCookie, keyPairs) {
  let addressActual;

  // トークン存在チェック

  // トークン保有量チェック

  let request = {};
  let messages = {};
  // let bodyObj = {};

  // state固定
  const stateFixed = {
    exhibitNo: state.cancelExhibit.exhibitNo,
    addressMain: state.cancelExhibit.addressMain,
    tokenName: state.cancelExhibit.tokenName,
    amountToSell: state.cancelExhibit.amountToSell,
    signatureVersion: state.config.clientParameters.signatureVersion.cancelExhibit,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // // Mpurseのアドレスが合ってるかチェック
  // const result = await window.mpurse.getAddress()
  // .then( (result) => {
  //   addressActual = result;

  //   if (stateFixed.addressCheck === 'strict' || stateFixed.addressCheck === 'addressSecond') {
  //     if (addressActual !== stateFixed.addressMain) {
  //       dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
  //       return 'rejected';
  //     }
  //     else {
  //       return 'fulfilled';
  //     }
  //   }
  //   else { // off
  //     return 'fulfilled';
  //   }
  // })
  // .catch( (error) => {
  //     dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
  //     return 'rejected';
  // });

  // if (result === 'rejected') {
  //   return { status: 'rejected' };
  // }

  // 署名
  const clientTime = Date.now();
  const message = `I cancel the exhibit; No.${stateFixed.exhibitNo} of ${stateFixed.addressMain}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });
  let signature;

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    const keyPair = keyPairsInPool[stateFixed.addressMain].keyPair;
    addressActual = stateFixed.addressMain;

    const result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return { status: 'rejected' };
    }

    // addressMainは必ず指定されている。
    if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressMain, addressCheck: stateFixed.addressCheck, language: state.language })) {
      return { status: 'rejected' };
    }

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (stateFixed.walletType === 'mpurse') {
    // キープールに鍵が無い。
    // Mpurseのアドレスが合ってるかチェック
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressActual = result;

      // addressMainは必ず指定されている。
      if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressMain, addressCheck: stateFixed.addressCheck, language: state.language })) {
        return 'rejected';
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    try {
      signature= await window.mpurse.signMessage(message).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (
    stateFixed.walletType === 'keypool' &&
    state.active.addressMain !== undefined && state.active.addressMain !== null && state.active.addressMain !== '' &&
    keyPairsInPool[state.active.addressMain]?.keyPair !== undefined
  ) {
    const keyPair = keyPairsInPool[state.active.addressMain].keyPair;
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return { status: 'rejected' };
    }

    // addressMainは必ず指定されている。
    if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressMain, addressCheck: stateFixed.addressCheck, language: state.language })) {
      return { status: 'rejected' };
    }

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else if (stateFixed.walletType === 'nfcNative') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcNativeRequired',
    };
  }
  else { // qr
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }

  // GO！

  request.body = JSON.stringify({
    "body": {
      "addressMain": stateFixed.addressMain,
      "addressMainActual": addressActual,
      "exhibitNo": stateFixed.exhibitNo,
      "clientTimeOfAddressMainCancel": clientTime,
      "signatureByAddressMainCancel": signature,
      "signatureVersionOfAddressMainCancel": stateFixed.signatureVersion,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/cancel_exhibit';
  request.method = 'POST';

  messages = {
    "addressMona must be filled.": words.addressMonaMustBeFilled[state.language],
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "order expired.": words.orderExpired[state.language],
    "out of service": words.outOfService[state.language],
    "you are not delegated from main address.": words.norIsTheSignatureDelegatedFromMainAddress[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    const sessionId = response.body.sessionId;
    const expirationOfSession = response.body.expirationOfSession;

    // cancel exhibit情報更新
    dispatch({ type: 'setState', key: 'cancelExhibit', value: response.body.cancelExhibit });

    // change exhibit情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['changeExhibit', 'status'], value: 'cancelled' });
    dispatch({ type: 'setStateMultiLayers', keys: ['changeExhibit', 'disabled'], value: true });

    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: {'sessionId': sessionId.addressMain, 'expirationOfSession': expirationOfSession.addressMain} });

    if (addressActual !== stateFixed.addressMain) {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': sessionId.addressMainActual, 'expirationOfSession': expirationOfSession.addressMainActual} });
    }

    // オーダーNo.通知欄表示
    // dispatch({ type: 'setNotification', key: 'notification', value: words.orderAcceptedOrderNo[state.language] + response.body.orderNo + words.orderAcceptedOrderNo2[state.language] });

    // cookie情報更新(アドレス情報)
    const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    const cookiesNew = [
          {
            action: 'cancel',
            addressType: 'addressMain',
            description: `${userName} ${stateFixed.tokenName} ${stateFixed.amountToSell}`,
            // addressMainExhibitor: stateFixed.addressMain,
            // tokenName: stateFixed.tokenName,
            // amount: stateFixed.amountToSell,
            time: clientTime,
            address: stateFixed.addressMain
          },
    ];

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
  }
  else {
  }

  return response;
}

// 「出品変更：署名」ボタン押下 -- HANDLE CLICK SIGN CHANGE EXHIBIT
async function handleClickSignChangeExhibit(state, dispatch, cookies, setCookie, keyPairs) {
  let addressActual;

  // トークン存在チェック

  // トークン保有量チェック

  let request = {};
  let messages = {};
  // let bodyObj = {};

  // state固定
  const stateFixed = {
    exhibitNo: state.changeExhibit.exhibitNo,
    addressMain: state.changeExhibit.addressMain,
    addressPayProceedsTo: state.changeExhibit.addressPayProceedsTo,
    priceMona: state.changeExhibit.priceMona.value,
    tokenName: state.changeExhibit.tokenName,
    amountToSell: state.changeExhibit.amountToSell,
    signatureVersion: state.config.clientParameters.signatureVersion.changeExhibit,
    minimumPriceMona: state.config.clientParameters.priceMonaRange.min,
    maximumPriceMona: state.config.clientParameters.priceMonaRange.max,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 必須項目チェック
  if (stateFixed.addressPayProceedsTo === undefined || stateFixed.addressPayProceedsTo === null || stateFixed.addressPayProceedsTo === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.addressYouReceiveProceedsInMustBeFilled[state.language] });
    return;
  }

  if (stateFixed.priceMona === undefined || stateFixed.priceMona === null || stateFixed.priceMona === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.unitPriceMustBeFilled[state.language] });
    return;
  }

  // 数量チェック
  if (stateFixed.priceMona < stateFixed.minimumPriceMona) {
    dispatch({ type: 'setNotification', key: 'notification',
      value: `${words.unitPriceMustBeEqualOrMoreThanXMona1[state.language]} ${stateFixed.minimumPriceMona} ${words.unitPriceMustBeEqualOrMoreThanXMona2[state.language]}`
    });
    return;
  }

  if (stateFixed.priceMona > stateFixed.maximumPriceMona) {
    dispatch({ type: 'setNotification', key: 'notification',
      value: `${words.unitPriceMustBeEqualOrLessThanXMona1[state.language]} ${stateFixed.maximumPriceMona} ${words.unitPriceMustBeEqualOrLessThanXMona2[state.language]}`
    });
    return;
  }

  // 署名
  const clientTime = Date.now();
  const message = `I cancel the exhibit; No.${stateFixed.exhibitNo} of ${stateFixed.addressMain}. I will take it over and sell token(s) for ${stateFixed.priceMona} MONA per unit. I want receive proceeds in ${stateFixed.addressPayProceedsTo}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });
  let signature;

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    const keyPair = keyPairsInPool[stateFixed.addressMain].keyPair;
    addressActual = stateFixed.addressMain;

    const result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return { status: 'rejected' };
    }

    // addressMainは必ず指定されている。
    if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressMain, addressCheck: stateFixed.addressCheck, language: state.language })) {
      return { status: 'rejected' };
    }

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (stateFixed.walletType === 'mpurse') {
    // キープールに鍵が無い。
    // Mpurseのアドレスが合ってるかチェック
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressActual = result;

      // addressMainは必ず指定されている。
      if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressMain, addressCheck: stateFixed.addressCheck, language: state.language })) {
        return 'rejected';
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    try {
      signature= await window.mpurse.signMessage(message).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (
    stateFixed.walletType === 'keypool' &&
    state.active.addressMain !== undefined && state.active.addressMain !== null && state.active.addressMain !== '' &&
    keyPairsInPool[state.active.addressMain]?.keyPair !== undefined
  ) {
    const keyPair = keyPairsInPool[state.active.addressMain].keyPair;
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return { status: 'rejected' };
    }

    // addressMainは必ず指定されている。
    if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressMain, addressCheck: stateFixed.addressCheck, language: state.language })) {
      return { status: 'rejected' };
    }

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else if (stateFixed.walletType === 'nfcNative') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcNativeRequired',
    };
  }
  else { // qr
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }

  // GO！

  request.body = JSON.stringify({
    "body": {
      "addressMain": stateFixed.addressMain,
      "addressMainActual": addressActual,
      "exhibitNo": stateFixed.exhibitNo,
      "addressPayProceedsTo": stateFixed.addressPayProceedsTo,
      "priceMona": stateFixed.priceMona,
      "clientTimeOfAddressMainChange": clientTime,
      "signatureByAddressMainChange": signature,
      "signatureVersionOfAddressMainChange": stateFixed.signatureVersion,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/change_exhibit';
  request.method = 'POST';

  messages = {
    "addressMona must be filled.": words.addressMonaMustBeFilled[state.language],
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "out of service": words.outOfService[state.language],
    "you are not delegated from main address.": words.norIsTheSignatureDelegatedFromMainAddress[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    const sessionId = response.body.sessionId;
    const expirationOfSession = response.body.expirationOfSession;
    const exhibit = response.body.exhibit;

    // change exhibit情報更新
    dispatch({ type: 'setState', key: 'changeExhibit', value: exhibit });

    // cancel exhibit情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['cancelExhibit', 'status'], value: 'takenOver' });

    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: {'sessionId': sessionId.addressMain, 'expirationOfSession': expirationOfSession.addressMain} });

    if (addressActual !== stateFixed.addressMain) {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': sessionId.addressMainActual, 'expirationOfSession': expirationOfSession.addressMainActual} });
    }

    // オーダーNo.通知欄表示(全署名完了していたら)
    if ( exhibit.signatureByAddressMain !== undefined && exhibit.signatureByAddressMain !== null && exhibit.signatureByAddressMain !== '' &&
         exhibit.signatureByAddressCardFrom !== undefined && exhibit.signatureByAddressCardFrom !== null && exhibit.signatureByAddressCardFrom !== '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.takenOverToExhibitNoX1[state.language] + exhibit.exhibitNo + words.takenOverToExhibitNoX2[state.language] });
    }

    // cookie情報更新(アドレス情報)
    const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    const cookiesNew = [
          {
            action: 'cancelAndReexhibit',
            addressType: 'addressMain',
            description: `${userName} ${stateFixed.tokenName} ${stateFixed.amountToSell}`,
            // addressMainExhibitor: stateFixed.addressMain,
            // tokenName: stateFixed.tokenName,
            // amount: stateFixed.amountToSell,
            time: clientTime,
            address: stateFixed.addressMain
          },
    ];

    if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressPayProceedsTo )) {
      cookiesNew.push(
          {
            action: 'cancelAndReexhibit',
            addressType: 'addressPayProceedsTo',
            description: `${userName} ${stateFixed.tokenName} ${stateFixed.amountToSell}`,
            time: clientTime,
            address: stateFixed.addressPayProceedsTo
          },
      );
    }

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
  }
  else {
  }

  return response;
}

export {
  handleClickGetExhibitHistory,
  handleClickGetPurchaseHistory,
  handleClickGetSalesHistory,
  handleClickGetRoyaltyHistory,
  handleClickSignCancelExhibit,
  handleClickSignChangeExhibit,
}
